import { render, staticRenderFns } from "./nif-driving-license-data.vue?vue&type=template&id=80638820"
import script from "./nif-driving-license-data.vue?vue&type=script&lang=js"
export * from "./nif-driving-license-data.vue?vue&type=script&lang=js"
import style0 from "./nif-driving-license-data.vue?vue&type=style&index=0&id=80638820&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports